// theme.js

// 1. import `extendTheme` function
import { extendTheme } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools';

// 2. Add your color mode config
const config = {
  initialColorMode: 'dark',
  useSystemColorMode: false,
};

const styles = {
  global: (props) => ({
    body: {
      bg: mode('gray.100', 'gray.800')(props),
    },
  }),
};

// light: #fafafa, gray.50  dark: #121212  #gray.800

const components = {
  Link: {
    baseStyle: {
      // normal styling
      textDecoration: 'none',
      // hover styling goes here
      _hover: {
        textDecoration: 'none',
      },
    },
  },
};

// 3. extend the theme
const theme = extendTheme({ config, components, styles});

export default theme;
